/* eslint-disable no-console */
import { useState, useEffect } from 'react'
import { mySalesService } from '../Services/mySalesService'

export const useFollowers = () => {
  const [followers, setFollowers] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchFollowers = async () => {
      try {
        setIsLoading(true)
        const followersData = await mySalesService.getFollowers()
        setFollowers(followersData)
        setError(null)
      } catch (err) {
        console.error('Error fetching followers:', err)
        setError(err.message || 'Error loading followers')
        setFollowers([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchFollowers()
  }, [])

  const handleFollowToggle = async (id, action) => {
    if (!action || !action.url) {
      console.error('Invalid action data:', action)
      return
    }

    try {
      const method = action.method
      const url = action.url

      await mySalesService.performFollowAction(url, method)

      setIsLoading(true)
      const followersData = await mySalesService.getFollowers()
      setFollowers(followersData)
      setError(null)
    } catch (err) {
      setError(err.message || 'Error updating follow status')
    } finally {
      setIsLoading(false)
    }
  }

  return {
    followers,
    isLoading,
    error,
    handleFollowToggle,
  }
}
